<template>
  <nav class="menu-container">
    <h3>丰列表</h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
      //  {
      //     // name: "Fengliebiao",
      //     title: "丰列表",
      //     // icon: "home",
      //     // exact: true,
      //   },
        {
          name: "Gongjiao",
          title: "公交",
          // icon: "blog",
          exact: false, // 激活状态是否要精确匹配
        },
        {
          name: "Ditie",
          title: "地铁",
          // icon: "about",
          exact: true,
        },
        {
         name: "Chuzuche",
         title: "出租车",
         // icon: "code",
         exact: true,
       },
        {
          name: "Gaotie",
          title: "高铁",
          // icon: "code",
          exact: true,
        },
        {
          name: "Jichang",
          title: "机场",
          // icon: "chat",
          exact: true,
        },
        {
          name: "Lunchuan",
          title: "轮船",
          // icon: "chat",
          exact: true,
        },
        // {
          // name: "Hesuan",
          // title: "核酸",
          // icon: "chat",
          // exact: true,
        // },
        // {
        //   name: "yihaoxian",
        //   title: "1",
        //   // icon: "chat",
        //   exact: true,
        // },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @gray; //左边left区域，字体颜色
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@green, 3%); //这里是改变左边字体链接点击下去，之后的背景块颜色 默认（background: darken(@words, 3%); ）
    }
    padding: 0 5px;  //左边left区域，字体链接的左右上下间距。左右5，上下0.
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: #fff;  //按下去，链接字体变成白色
    }
  }
}
</style>
